"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZRX_PROXY_CONTRACT = void 0;
exports.ZRX_PROXY_CONTRACT = '0xDef1C0ded9bec7F1a1670819833240f027b25EfF';
